function Logo() {
  return (
    <div className="flex leading-12 font-['KGLifeisMessy'] ">
      <div className="m-1">
        <span className="text-[#B018C8]">V</span>
        <span className="text-sky-800 ">i</span>
        <span className="text-[#4B0082]">n </span>
        <span className="text-sky-500 text-5xl leading-8">L</span>
        <span className="text-lime-500">i</span>
        <span className="text-yellow-500 ">n</span>
        <span className="text-[#FF7F00]">g</span>
        <span className="text-[#DA0C0C] ">u</span>
        <span className="text-lime-800 ">a</span>
      </div>
    </div>
  );
}

export default Logo;
